import React from 'react';
import {
  Button,
} from 'antd';
import PropTypes from 'prop-types';
import {
  Flex, Text,
} from '../../shared/components';

export default function FooterCrearEncargo({ onClickGuardarEncargo, visible }) {
  if (!visible) return <></>;
  return (
    <Flex
      p="16px 40px 16px 80px"
      bg="white"
      style={{
        boxShadow: '0 -2px 8px 0 rgba(0,0,0,0.15)',
        position: 'fixed',
        height: '72px',
        width: '100%',
        left: '0',
        bottom: '0',
      }}
      justifyContent="space-between"
    >
      <Button size="large"><Text translationId="generico.cancelar" /></Button>
      <Flex>
        <Button style={{ marginRight: '8px' }} size="large"><Text translationId="encargos.guardar_como_presupuesto" /></Button>
        <Button size="large" type="primary" onClick={() => onClickGuardarEncargo()}><Text translationId="encargos.guardar_como_encargo" /></Button>
      </Flex>
    </Flex>
  );
}

FooterCrearEncargo.propTypes = {
  onClickGuardarEncargo: PropTypes.func.isRequired,
};
